import { apiClient } from '@/core/infra_api_client'

// ============= Types =============

export interface SshKey {
  id: string
  name: string
  publicKey: string
  fingerprint: string
  keyType: string
  vaultPath?: string
  createdAt: string
  createdBy: string
}

export interface CreateSshKeyRequest {
  name: string
  publicKey: string
  privateKey?: string
}

export interface PaginatedResponse<T> {
  data: T[]
  total: number
  page: number
  perPage: number
  totalPages: number
}

// ============= API =============

const BASE_PATH = 'ssh-keys'

export async function listSshKeys(params?: {
  page?: number
  perPage?: number
}): Promise<PaginatedResponse<SshKey>> {
  const searchParams: Record<string, string | number | boolean> = {}
  if (params?.page) searchParams['page'] = params.page
  if (params?.perPage) searchParams['per_page'] = params.perPage

  return apiClient.get<PaginatedResponse<SshKey>>(BASE_PATH, searchParams)
}

export async function createSshKey(data: CreateSshKeyRequest): Promise<SshKey> {
  return apiClient.post<SshKey, CreateSshKeyRequest>(BASE_PATH, data)
}

export async function deleteSshKey(id: string): Promise<void> {
  return apiClient.delete(`${BASE_PATH}/${id}`)
}

export interface GenerateSshKeyResponse extends SshKey {
  privateKey: string
}

export async function generateSshKey(name: string): Promise<GenerateSshKeyResponse> {
  return apiClient.post<GenerateSshKeyResponse>('ssh-keys/generate', { name })
}
